import React from "react";

import { UI_COLORS, OVERLAY_COLORS } from "@perceptron/constants/colors";

import { cn } from "@perceptron/utils/cn";

interface ToolbarButtonProps {
  onClick: () => void;
  disabled?: boolean;
  active?: boolean;
  icon: React.ReactNode;
  label: string;
  className?: string;
}

export function ToolbarButton({
  onClick,
  disabled = false,
  active = false,
  icon,
  label,
  className,
}: ToolbarButtonProps) {
  return (
    <button
      className={cn(
        "flex items-center gap-2 rounded-lg px-2 py-2 text-sm font-normal leading-5 transition-all md:px-4",
        {
          "bg-brand-blue text-white hover:bg-brand-blue-hover": active,
          "cursor-not-allowed text-white/30": !active && disabled,
          "bg-toolbar-button text-white/70 hover:bg-toolbar-button-hover hover:text-white": !active && !disabled,
        },
        className,
      )}
      disabled={disabled}
      style={{
        boxShadow: `0px 4px 4px ${OVERLAY_COLORS.OVERLAY_MEDIUM}`,
        ...(!active &&
          !disabled && {
            "&:hover": {
              backgroundColor: UI_COLORS.EDITOR_TOOLBAR_HOVER,
            },
          }),
      }}
      onClick={onClick}
      onTouchEnd={(e) => {
        // Handle the action directly on touchEnd to avoid iOS double-tap issue
        // This ensures the action happens on the first tap
        if (!disabled && e.changedTouches.length > 0) {
          e.preventDefault(); // Prevent any default touch behavior
          onClick();
        }
      }}
    >
      <span className={cn(disabled ? "text-zinc-600" : active ? "text-white" : "text-zinc-400")}>{icon}</span>
      <span className="hidden md:inline">{label}</span>
    </button>
  );
}
